import { render, staticRenderFns } from "./mini-program-path.vue?vue&type=template&id=033f651d&"
import script from "./mini-program-path.vue?vue&type=script&lang=ts&"
export * from "./mini-program-path.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports